/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotGarageHandlingValues = ["left", "right"] as const;
export type LotGarageHanding = (typeof lotGarageHandlingValues)[number];

/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotSpecValues = ["none", "spec", "model"] as const;
export type LotSpec = (typeof lotSpecValues)[number];

/**
 * Needs to be kept in sync with DB enum values.
 */
export const lotStatusValues = ["available", "unavailable", "pending", "sold", "closed"] as const;
export type LotStatus = (typeof lotStatusValues)[number];

/**
 * Symbols shown as map/legend badges: the real lot statuses, plus "spec" and "model" which are
 * derived from a lot's status + spec designation (see `getLotBadgeSymbol` in `lotBadge.ts`).
 */
export const LOT_BADGE_SYMBOLS = [
  "available",
  "spec",
  "model",
  "pending",
  "sold",
  "closed",
  "unavailable",
] as const satisfies readonly (LotStatus | "spec" | "model")[];
export type LotBadgeSymbol = (typeof LOT_BADGE_SYMBOLS)[number];

/** Lot statuses that mean a unit Home Plan has progressed past preparation (mirrors UnitPlanStatus phases). */
const unitHomePlanLockableLotStatusValues = ["pending", "sold", "closed"] as const satisfies readonly LotStatus[];

export function lotStatusAllowsUnitLock(lotStatus: LotStatus | undefined): boolean {
  if (!lotStatus) {
    return false;
  }
  return (unitHomePlanLockableLotStatusValues as readonly LotStatus[]).includes(lotStatus);
}

/** Declared here, not in `lotsRequests`: a client value-import of that module pulls in zod. */
export const MAX_LOTS_PER_REQUEST = 1000;

export const MAX_LOTS_PER_PAGE = 1000;
